var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrLeftPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.63951 11.7318C6.01642 12.0894 6.62753 12.0893 7.00431 11.7318C7.38135 11.374 7.38135 10.7941 7.00419 10.4362L3.29556 6.91641L14.035 6.91543C14.568 6.91531 15 6.5053 15 5.99917C14.9999 5.49328 14.5679 5.0834 14.0349 5.0834L3.29504 5.08437L7.00457 1.56382C7.38148 1.20609 7.38148 0.625944 7.00457 0.268331C6.81605 0.0895251 6.56911 0 6.32204 0C6.0751 0 5.82816 0.0895251 5.63964 0.268209L0.282716 5.35246C0.101659 5.52418 0 5.7571 0 6.00015C0.000128682 6.2432 0.101788 6.47599 0.282844 6.64807L5.63951 11.7318Z",
    fill: "#29185E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrLeftPopup);
export default __webpack_public_path__ + "static/media/arr-left-popup.fc6e199956f0c4af45e534688b4f69a7.svg";
export { ForwardRef as ReactComponent };